import Vue from 'vue'
import $ from 'jquery';
import moment from "moment";
import * as functionsCandys from "./functionsCandys.js";

/*Section Ticket/Candy*/
import PopupCinemasHome from "./components/PopupCinemasHome.vue";
import PopupCinemas from "./components/PopupCinemas.vue";
import PopupCandyHome from "./components/PopupCandyHome.vue";
import PopupCandy from "./components/PopupCandy.vue";
import PopupGalleryHome from "./components/PopupGalleryHome.vue";
import PopupGallery from "./components/PopupGallery.vue";
import PopupAlert from "./components/PopupAlert.vue";
import PopupImage from "./components/PopupImage.vue";
import Total from "./components/Total.vue";

/*Section Candy*/
import CandyCategoryHome from "./components/CandyCategoryHome.vue";
import CandyTicketHome from './components/CandyTicketHome.vue'
import CandyCategory from "./components/CandyCategory.vue";
import CandyTicket from './components/CandyTicket.vue'
import CandyCart from "./components/CandyCart.vue";

import Banner from "./components/Banner.vue"
import PopupBoms from "./components/PopupBoms.vue";

//Mode Dev
Vue.config.devtools = false;

require("sumoselect");

var vm = new Vue({
  el: '#app',
  components: {
    /*Section Ticket/Candy*/
    "v-popup-cinemas-home": PopupCinemasHome,
    "v-popup-cinemas": PopupCinemas,
    "v-popup-candy-home": PopupCandyHome,
    "v-popup-candy": PopupCandy,
    "v-popup-gallery-home": PopupGalleryHome,
    "v-popup-gallery": PopupGallery,
    "v-popup": PopupAlert,
    "v-popup-image": PopupImage,
    "v-total": Total,

    /*Section Candy*/
    "v-candycategoryhome": CandyCategoryHome,
    "v-candytickethome": CandyTicketHome,
    "v-candycategory": CandyCategory,
    "v-candyticket": CandyTicket,
    "v-candycart": CandyCart,
    "v-banner": Banner,
    "v-popup-boms": PopupBoms,
  },
  data: {
    //Si hay un member logueado.
    d_member: null,

    //Lista de cines
    d_cinemas: null,

    //Lista de BalanceTypes
    d_balance_types: [],

    /*Section Candy*/
    //Subtotal de la orden
    d_subtotal_value: 0,
    //Datos de las categorias con los candys.
    d_json_candys: null,
    //Carrito de candys.
    d_cart_candys: null,
    //Cantidad totales de candys que se pueden agregar a la orden.
    d_qty_candys_operation: 3,
    //total para los tickets.
    d_total_candy: '$0',
    //Subtotal para los candys
    d_subtotal_candy: '$0',
    //Service candys para los candys
    d_c_service_candy: '$0',
    //Total value de candys para sumar en el total de tickets.
    d_total_candys_value: 0,
    //Total de service charge para sumar en el total de tickets.
    d_total_candys_service: 0,
    //Service charge por defecto a sumar en el carrito de candys.
    d_default_candys_service: 0,

    // Definicion de constantes para validar exclusividad del Member a los productos.
    d_get_exclusive_merch_mcodes: window.ExclusiveMerchMCodes,
    d_get_exclusive_dtm_cf: window.ExclusiveDTMCF,
    d_get_exclusive_msg_cf: window.ExclusiveMSGCF,
    d_get_exclusive_dtm_bsc: window.ExclusiveDTMBSC,
    d_get_exclusive_msg_bsc: window.ExclusiveMSGBSC,

    // Definicion de constantes para texto mensaje de descuento.
    d_get_discount_msg_productlist: window.DiscountPListMsg,

    //Definicion de contante para determinar la lista de productos con descuento BBVA
    d_get_discount_bbva_product_list: window.DiscountBBVAPList,

    //Definicion de contante para determinar los mensajes de los productos con descuento BBVA
    d_get_discount_bbva_product_msgs: window.DiscountBBVAPMsgs,

    // Definicion de urls.
    d_get_url_merch: window.UrlMerch,
    d_get_url_candys: window.UrlCandys,
    d_get_url_web: window.UrlWeb,
    d_get_url_ticketing: window.UrlTicketing,
    d_get_url_candy_images: window.UrlStaticContentCandyImages,
    // Definicion de fecha de versionado de cache
    d_get_date_version_cache: window.DateVersionCache,
    d_get_url_candy_booms_images: window.UrlStaticContentCandyBoomsImages,
    d_group_rules_candys: [],

    // Para navegación en Apps
    d_App: window.App,

    ///////////////////
    // DATALAYER GA4 //
    ///////////////////

    d_datalayer: null,
    d_base_item: null,
    d_current_item: null,
    d_dl_total: 0,
    d_cinema_selected: null,

    //Mostrar descripciones de Deals
    d_show_promotion_desc: false
  },
  watch: {
    /*Section Candy*/
    d_cart_candys: function () {
      this.m_calculate_total_candy();
      //habilito/deshabilito el boton de siguiente si hay o no elementos en el carrito.
      $('#btnNext').prop('disabled', !(this.d_cart_candys && this.d_cart_candys.length > 0));

      var qty = functionsCandys.GetQty(this.d_json_candys, this.d_cart_candys);
      if (qty) {
        $('.cart-counter.cart-counter_candy').addClass('active').find('.cart-counter-value').html("( " + qty + " )");
      }
      else {
        $('.cart-counter.cart-counter_candy').removeClass('active');
      }
    }
  },
  computed: {
    /*Section Candy*/
    //Devuelve las categorias con los candy.
    c_get_categories_candy: function () {
      return this.d_json_candys;
    },
    //Devuelve el carrito con los candys.
    c_get_cart_candys: function () {
      return this.d_cart_candys;
    }
  },
  methods: {

    ////////////////////////
    /*Section Ticket/Candy*/
    ////////////////////////

    m_change_cinema_home: function (value) {
      this.$refs.popupcinemashome.onChange(value);
    },
    m_change_cinema: function (value) {
      this.$refs.popupcinemas.onChange(value);
    },
    //Abre el popup con el mensaje dependiendo de los argumentos.
    m_show_popup_cinemas_home: function (candy, recogid, recogtypeid, promoid, barcode) {
      this.$refs.popupcinemashome.m_open(candy, recogid, recogtypeid, promoid, barcode);
    },
    //Abre el popup con el mensaje dependiendo de los argumentos.
    m_show_popup_cinemas: function (cinemas) {
      this.$refs.popupcinemas.m_open(cinemas);
    },
    //Funcion para inicializar MagnificPopup.
    //Parametro srcPopup para indicar en que elemento se va a inicializar.
    //Parametro srcGalery para indicar la galeria del popup.
    //Parametro typePopup para indicar el tipo de popup.
    //Parametro classPopup para indicar una clase main al popup.
    //Parametro fixedTop para indicar si el popup estara posicionado,en desktop y mobile, siempre al top de la pantalla
    m_init_magnific_popup(srcPopup, srcGalery, typePopup, classPopup, fixedTop) {
      $.magnificPopup.open({
        items: {
          src: srcPopup
        },
        type: typePopup,
        mainClass: classPopup,
        closeOnBgClick: false,
        fixedContentPos: fixedTop,
        callbacks: {
          beforeOpen: function () {
            //Oculto Popup
            $(srcPopup).hide();

            setTimeout(function () {
              // Consulto si existe la galeria, y la desarmo
              if ($(srcGalery).hasClass('slick-initialized')) {
                $(srcGalery).slick('unslick');
              }

              // Inicializo una nueva galeria
              $(srcGalery).not('.slick-initialized').slick({
                infinite: true,
                slidesToShow: 1,
                dots: true,
                arrows: false,
                slidesToScroll: 1,
                draggable: false
              });

              // Visualizo el Popup
              $(srcPopup).show();
            }, 100); // 1 milisegundo de tiempo de espera
          },
          close: function () {
            // Consulto si existe la galeria, y la desarmo
            if ($(srcGalery).hasClass('slick-initialized')) {
              $(srcGalery).slick('unslick');
            }
          }
        }
      });
    },
    //Abre el popup con el mensaje dependiendo de los argumentos.
    m_show_popup_candy_home: function (args) {
      // DataLayerGA4
      this.$root.m_datalayer_select_item_home(args);
      window.PushDataLayer();

      this.$refs.popupcandyhome.m_open(args);
    },
    //Abre el popup con el mensaje dependiendo de los argumentos.
    m_show_popup_candy: function (args) {
      // DataLayerGA4
      this.$root.m_datalayer_select_item(args);
      window.PushDataLayer();

      this.$refs.popupcandy.m_open(args);
    },
    //Abre el popup con el mensaje dependiendo de los argumentos.
    m_show_popup_gallery_home: function (args) {
      this.$refs.popupgalleryhome.m_open(args);
    },
    //Abre el popup con el mensaje dependiendo de los argumentos.
    m_show_popup_gallery: function (args) {
      this.$refs.popupgallery.m_open(args);
    },
    //Abre el popup con el mensaje dependiendo de los argumentos.
    m_show_popup: function (args) {
      this.$refs.popupalert.m_open(args);
    },
    //Abre el popup con el mensaje dependiendo de los argumentos.
    m_show_popup_image: function (args) {
      this.$refs.popupimage.m_open(args);
    },
    //Retorna el nombre del balance type.
    m_get_balance_name: function (enuPointsType, intBalanceTypeId, forCart = null, plural = true) {
      var balancetype = this.d_balance_types.find(item => item.enuPointsType == enuPointsType && item.intBalanceTypeId == intBalanceTypeId);
      if (balancetype != null)
        return (forCart ? balancetype.strCartName : this.m_plural(balancetype.strName, plural));
      else
        return ""
    },
    m_plural: function (Name, plural = true) {
      if (plural) {
        Name = Name.replace(/\bENTRADA\b/, "ENTRADAS");
        Name = Name.replace(/\bEntrada\b/, "Entradas");
        Name = Name.replace(/\bPUNTO\b/, "PUNTOS");
        Name = Name.replace(/\bPunto\b/, "Puntos");
      } else {
        Name = Name.replace(/\bENTRADAS\b/, "ENTRADA");
        Name = Name.replace(/\bEntradas\b/, "Entrada");
        Name = Name.replace(/\bPUNTOS\b/, "PUNTO");
        Name = Name.replace(/\bPuntos\b/, "Punto");
      }
      return Name;
    },

    /////////////////
    /*Section Candy*/
    /////////////////

    //Retorna la cantidad de puntos de candys para un balance type.
    m_get_candys_total_balance_points: function (JsonCandys, CartCandys, enuPointsType, intBalanceTypeId) {
      if ((CartCandys == null) || (enuPointsType == 0 && intBalanceTypeId == 0))
        return 0;
      var totalPoints = 0;
      CartCandys.forEach(orderItem => {
        var candy = functionsCandys.GetCandy(JsonCandys, orderItem.strMCode, orderItem.strBarcode);
        var option = functionsCandys.GetOption(candy, orderItem.intRecogId, orderItem.intPromoId);
        // Recorro los Balance del Option
        option.lstBalances.forEach(balance => {
          if (balance.enuPointsType == enuPointsType && balance.intBalanceId == intBalanceTypeId)
            totalPoints += (orderItem.intQty * balance.intPoints);
        });
      });
      var balancetype = this.d_balance_types.find(item => item.enuPointsType == enuPointsType && item.intBalanceTypeId == intBalanceTypeId);
      return totalPoints + balancetype.intOrderPoints;
    },

    //Retorna un string con el total de precio + puntos del carrito.
    m_get_candys_string_total_value_and_points: function (JsonCandys, CartCandys, total_tickets_value, total_tickets_service) {
      if (CartCandys == null)
        return '$0';
      var totalPrice = 0;
      var qty = 0;

      CartCandys.forEach(orderItem => {
        var candy = functionsCandys.GetCandy(JsonCandys, orderItem.strMCode, orderItem.strBarcode);
        var option = functionsCandys.GetOption(candy, orderItem.intRecogId, orderItem.intPromoId);
        orderItem.boms.forEach(b => {
          b.Options.forEach(option => {
            totalPrice = totalPrice + ((option.intQty * option.intPrice) * orderItem.intQty);
          })
        })
        totalPrice = totalPrice + (orderItem.intQty * option.intValue);
        qty = qty + 1;
      });

      // Sumo service charge de candy
      if (this.d_default_candys_service == 0) {
        // DataLayerGA4 - Persisto el total en d_dl_total
        this.d_dl_total = totalPrice / 100;

        // Si estoy en nsMerchansing.aspx sumo d_total_candys_service
        totalPrice = totalPrice + this.d_total_candys_service;
      }
      else {
        // En estoy en nsCandys.aspx sumo default_candys_service si tengo elementos en CartCandys 
        if (totalPrice > 0)
          totalPrice = totalPrice + this.d_default_candys_service;

        // DataLayerGA4 - Persisto el total en d_dl_total
        this.d_dl_total = totalPrice / 100;
      }

      var price = (((totalPrice + total_tickets_value + total_tickets_service) / 100).toLocaleString('es-AR'));
      var result = "$" + price;

      // Recorro balance types
      this.d_balance_types.forEach(balanceItem => {
        var totalPoints = this.m_get_candys_total_balance_points(JsonCandys, CartCandys, balanceItem.enuPointsType, balanceItem.intBalanceTypeId);
        if (totalPoints > 0)
          result = result + " + " + totalPoints.toLocaleString('es-AR') + " " + balanceItem.strCartName;
      });
      return result;
    },
    //Obtine el ticket de candys de los disponibles.
    m_get_ticket_candy: function (strMCode, strBarcode) {
      return functionsCandys.GetCandy(this.d_json_candys, strMCode, strBarcode);
    },
    //Obtiene el option de un candys por el intRecogId y intPromoId.
    m_get_option_candy: function (TicketCandy, intRecogId, intPromoId) {
      return functionsCandys.GetOption(TicketCandy, intRecogId, intPromoId);
    },
    //Agrega una unidad del candy al carrito de candys.
    m_add_candy: function (strMCode, strBarcode, intRecogId, intPromoId, boms) {
      var candy = functionsCandys.GetCandy(this.d_json_candys, strMCode, strBarcode);
      var option = functionsCandys.GetOption(candy, intRecogId, intPromoId);

      //Si el producto esta flagueado como producto exclusivo, consulto las reglas de exclusividad del Member
      if (functionsCandys.ValidateExclusiveProduct(this.d_get_exclusive_merch_mcodes, strMCode)) {
        //Consulto el acceso a la exclusividad del Member
        var res = functionsCandys.ValidateLevelMemberExclusive(this.d_member, this.d_get_exclusive_dtm_cf, this.d_get_exclusive_dtm_bsc);

        //No permito agregar el producto a la orden/carrito porque el Member no paso la regla de exclusividad.
        if (res != 0) {
          if (res == -1) {
            //Muestro POPIN con mensaje de exclusividad CINE FAN
            var messageCineFan = this.d_get_exclusive_msg_cf;

            this.m_show_popup({ idMsg: 3006, message: messageCineFan });
            return false;
          }

          if (res == -2) {
            //Muestro POPIN con mensaje de exclusividad BASICO
            var messageBasico = this.d_get_exclusive_msg_bsc;

            this.m_show_popup({ idMsg: 3006, message: messageBasico });
            return false;
          }
        }
      }

      //Verifico si la orden es onlybook no dejo seleccionar candys onlybuy
      if (this.d_only_book && (candy.bitOnlyBuy || intRecogId != 0)) {
        this.m_show_popup({ idMsg: 3002 });
        return false;
      }

      //Si tiene regla de grupo verifico que no haya sido agregado un candy y sino
      //lo agrego a la lista de control. //flag = true: agrega regla, flag = false: quita regla
      if (candy.strGroupRule) {
        var ruleItem = this.d_group_rules_candys.find(item => (item.strGroupRule == candy.strGroupRule && item.strMCode != candy.strMCode));

        if (ruleItem) {
          this.m_show_popup({ idMsg: 3003, strTitle: ruleItem.strTitle });
          return false;
        }
      }

      //Obtengo la cantidad de candys seleccionados.
      var qty_candys_selected = functionsCandys.GetQty(this.d_json_candys, this.d_cart_candys);

      if (qty_candys_selected + option.intButtonQty > this.d_qty_candys_operation) {
        //lanza el popin en caso de que se supere la cantidad maxima de tickets seleccionados
        this.m_show_popup({ idMsg: 3000, candysQtyOperation: this.d_qty_candys_operation });
      }
      else {
        var optionQty = functionsCandys.GetQty(this.d_json_candys, this.d_cart_candys, strMCode, strBarcode, intRecogId, intPromoId);

        if (optionQty + option.intButtonQty > option.intMaxQty) {
          this.m_show_popup({ idMsg: 3001, strTitle: candy.strTitle, candysMaxQty: option.intMaxQty });
        }
        else {
          var enoughPoints = true;

          // Recorro los Balance del Option
          option.lstBalances.forEach(balance => {
            var balanceType = this.d_balance_types.find(item => item.enuPointsType == balance.enuPointsType && item.intBalanceTypeId == balance.intBalanceId);

            if (balanceType != null) {
              // Calculo puntos usados
              var balacePointsUsed = this.m_get_candys_total_balance_points(this.d_json_candys, this.d_cart_candys, balance.enuPointsType, balance.intBalanceId);

              // Defino puntos disponibles
              var balancePointsAvailable = balanceType.intMemberPoints - balacePointsUsed;
            }
            else {
              var balancePointsAvailable = 0;
            }

            // Si no dispongo de los suficientes puntos
            if (balancePointsAvailable - balance.intPoints < 0) {
              enoughPoints = false;
              this.m_show_popup({ idMsg: 1, memberPoints: balancePointsAvailable, requiredPoints: balance.intPoints - balancePointsAvailable, balanceNameAlt: balanceType.strNameAlt });
            }
          });

          if (enoughPoints) {
            if (candy.BOMs && candy.BOMs.length > 0) {
              this.$root.$refs.popupboms.m_open(candy, option);
            }
            else {
              this.d_cart_candys = functionsCandys.UpdateOrder(this.d_cart_candys, strMCode, strBarcode, intRecogId, option.intButtonQty, boms, option.intPromoId);
              this.m_update_group_rule_candy(candy, true);
              this.m_calculate_total_candy();
            }
          }
        }
      }

      var qty = functionsCandys.GetQty(this.d_json_candys, this.d_cart_candys);

      if (qty) {
        $('.cart-counter.cart-counter_candy').addClass('active').find('.cart-counter-value').html("( " + qty + " )");
      }
      else {
        $('.cart-counter.cart-counter_candy').removeClass('active');
      }
    },
    //Quita una unidad del candy del carrito de candys.
    m_del_candy: function (strMCode, strBarcode, intRecogId, intPromoId, boms) {
      var candy = functionsCandys.GetCandy(this.d_json_candys, strMCode, strBarcode);
      var option = functionsCandys.GetOption(candy, intRecogId, intPromoId);
      this.d_cart_candys = functionsCandys.UpdateOrder(this.d_cart_candys, strMCode, strBarcode, intRecogId, -option.intButtonQty, boms, option.intPromoId);
      this.m_calculate_total_candy();
      if (candy.strGroupRule) {
        var candyQty = functionsCandys.GetQty(this.d_json_candys, this.d_cart_candys, strMCode, strBarcode, intRecogId, intPromoId);
        candyQty == 0 && this.m_update_group_rule_candy(candy, false);
      }
      var qty = functionsCandys.GetQty(this.d_json_candys, this.d_cart_candys);

      if (qty) {
        $('.cart-counter.cart-counter_candy').addClass('active').find('.cart-counter-value').html("( " + qty + " )");
      }
      else {
        $('.cart-counter.cart-counter_candy').removeClass('active');
      }
    },
    //Borra todos los tickets dependiendo del strMCode.
    m_del_all_ticket_candy: function (strMCode, strBarcode, intRecogId, intQty, boms, intPromoId) {
      //Obtengo el ticket candy
      var candy = functionsCandys.GetCandy(this.d_json_candys, strMCode, strBarcode);
      //Obtengo el option para usar el intButtonQty
      var option = functionsCandys.GetOption(candy, intRecogId, intPromoId);
      //Itero para borrar todos los items del carrito.
      for (let index = 0; index < intQty / option.intButtonQty; index++) {
        this.m_del_candy(strMCode, strBarcode, intRecogId, intPromoId, boms);
      }
    },
    //Retorna la cantidad de candys totales o por strMCode, strBarcode, intRecogId Y intPromoId.
    m_get_ticket_candy_qty: function (strMCode, strBarcode, intRecogId, intPromoId) {
      return functionsCandys.GetQty(this.d_json_candys, this.d_cart_candys, strMCode, strBarcode, intRecogId, intPromoId);
    },
    //Calcula el total de los candys en el carrito entre precio y puntos.
    m_calculate_total_candy: function () {
      this.d_subtotal_candy = functionsCandys.GetStringSubtotalValue(this.d_json_candys, this.d_cart_candys, this.d_subtotal_value);
      this.d_c_service_candy = functionsCandys.GetStringCandysServiceValue(this.d_json_candys, this.d_cart_candys, this.d_total_candys_service, this.d_default_candys_service);
      this.d_total_candy = this.m_get_candys_string_total_value_and_points(this.d_json_candys, this.d_cart_candys, this.d_subtotal_value, 0);
    },
    //Trae el nombre del primer elemento del carrito de candys solo compra .
    m_first_candy_only_buy: function () {
      return functionsCandys.FirsItemOnlyBuy(this.d_json_candys, this.d_cart_candys);
    },
    m_is_cinefan: function (id) {
      return window.cinefanCategoryId == id;
    },
    //Agrega o elimina en d_group_rules_candys los grupos de los candys seleccionados.
    //flag = true: agrega regla, flag = false: quita regla
    m_update_group_rule_candy: function (candy, flag) {
      //Genero el nuevo item.
      var newGroupItem = { strGroupRule: candy.strGroupRule, strMCode: candy.strMCode, strTitle: candy.strTitle };
      if (flag) {
        //Busco si ya se encuentra el grupo cargado sino lo agrego.
        var ruleItem = this.d_group_rules_candys.find(item => item.strGroupRule == newGroupItem.strGroupRule);
        !ruleItem && this.d_group_rules_candys.push(newGroupItem);
      } else {
        //Si se encuentra lo elimino.
        var index = this.d_group_rules_candys.findIndex(item => item.strGroupRule == newGroupItem.strGroupRule);
        index > -1 && this.d_group_rules_candys.splice(index, 1);
      }
    },
    ///////////////////
    // DATALAYER GA4 //
    ///////////////////
    // Retorno intCategoryId y strTitle de la categoria de un Ticket
    findCategoryByCandyCode(strMCode) {
      for (const category of this.d_json_candys) {
        for (const candy of category.Candys) {
          if (candy.strMCode === strMCode) {
            return {
              intCategoryId: category.intCategoryId,
              strTitle: category.strTitle
            };
          }
        }
      }
      return null; // Retorna null si no se encuentra la categoría
    },
    m_datalayer_select_item_home: function (candy) {
      try {
        // Actualizo currency
        this.d_datalayer.ecommerce.currency = undefined;

        // Actualizo value
        this.d_datalayer.ecommerce.value = undefined;

        // Actualizo affiliation
        this.d_datalayer.ecommerce.affiliation = undefined;

        // Actualizo payment_type
        this.d_datalayer.ecommerce.payment_type = undefined;

        // Item
        this.d_datalayer.ecommerce.items[0].item_name = candy.strTitle;
        this.d_datalayer.ecommerce.items[0].item_id = candy.strMCode;
        this.d_datalayer.ecommerce.items[0].price = candy.SalePrice / 100;

        this.d_datalayer.ecommerce.items[0].item_category = "Merch";

        // Busco la categoria
        const category = this.findCategoryByCandyCode(candy.strMCode);
        this.d_datalayer.ecommerce.items[0].item_category2 = category.strTitle;
        this.d_datalayer.ecommerce.items[0].item_list_name = category.strTitle;
        this.d_datalayer.ecommerce.items[0].item_list_id = category.intCategoryId;

        this.d_datalayer.ecommerce.items[0].index = 1;
      } catch (error) {
        // Manejo del error
        //console.error('Se produjo un error:', error);
      }
    },
    m_datalayer_select_item: function (candy) {
      try {
        // Actualizo currency
        this.d_datalayer.ecommerce.currency = undefined;

        // Actualizo value
        this.d_datalayer.ecommerce.value = undefined;

        //Cine selecionado
        var cine_selected;

        //Consulto si hay un cine selecionado
        if (this.d_cinema_selected && this.d_cinema_selected > 0) {
          //Busco el cine
          this.d_cinemas.forEach(optionItem => {
            if (optionItem.CinemaId == this.d_cinema_selected) {
              cine_selected = optionItem;
            }
          });
        }

        // Actualizo affiliation
        if (cine_selected) {
          if (cine_selected.strName.includes("Cinemark")) {
            this.d_datalayer.ecommerce.affiliation = "Cinemark";
          }
          else {
            this.d_datalayer.ecommerce.affiliation = "Hoyts";
          }
        }

        // Actualizo payment_type
        this.d_datalayer.ecommerce.payment_type = undefined;

        // Item
        this.d_datalayer.ecommerce.items[0].item_name = candy.strTitle;
        this.d_datalayer.ecommerce.items[0].item_id = candy.strMCode;
        this.d_datalayer.ecommerce.items[0].price = candy.SalePrice / 100;

        this.d_datalayer.ecommerce.items[0].item_category = "Merch";

        // Busco la categoria
        const category = this.findCategoryByCandyCode(candy.strMCode);
        this.d_datalayer.ecommerce.items[0].item_category2 = category.strTitle;
        this.d_datalayer.ecommerce.items[0].item_list_name = category.strTitle;
        this.d_datalayer.ecommerce.items[0].item_list_id = category.intCategoryId;

        this.d_datalayer.ecommerce.items[0].index = 1;
      } catch (error) {
        // Manejo del error
        //console.error('Se produjo un error:', error);
      }
    },
    m_datalayer_set_merchandisings: function (CartCandys) {
      // Event
      this.d_datalayer.event = "add_to_cart";

      // Actualizo currency
      this.d_datalayer.ecommerce.currency = "ARS";

      // Actualizo value
      this.d_datalayer.ecommerce.value = this.d_dl_total;

      //Cine selecionado
      var cine_selected;

      //Consulto si hay un cine selecionado
      if (this.d_cinema_selected && this.d_cinema_selected > 0) {
        //Busco el cine
        this.d_cinemas.forEach(optionItem => {
          if (optionItem.CinemaId == this.d_cinema_selected) {
            cine_selected = optionItem;
          }
        });
      }

      // Actualizo affiliation
      if (cine_selected) {
        if (cine_selected.strName.includes("Cinemark")) {
          this.d_datalayer.ecommerce.affiliation = "Cinemark";
        }
        else {
          this.d_datalayer.ecommerce.affiliation = "Hoyts";
        }
      }

      // Actualizo payment_type
      this.d_datalayer.ecommerce.payment_type = undefined;

      // Vacía la lista de items
      this.d_datalayer.ecommerce.items.length = 0;

      // Difino Index
      var Index = 1;

      // Recorro CartCandys
      CartCandys.forEach(function (Item) {
        var candy = this.m_get_ticket_candy(Item.strMCode, Item.strBarcode);
        var option = this.m_get_option_candy(candy, Item.intRecogId, Item.intPromoId);

        // Map de d_base_item
        this.d_current_item = Object.assign({}, this.d_base_item);
        this.d_current_item.item_name = candy.strTitle;
        this.d_current_item.item_id = candy.strMCode;
        this.d_current_item.price = option.intValue / 100;

        // Puntos Cine Fan
        const puntosCineFanBalance = option.lstBalances.find(balance => balance.enuPointsType === 1 && balance.intBalanceId === 1);
        if (puntosCineFanBalance) {
          this.d_current_item.puntos_cinefan = Item.intQty * puntosCineFanBalance.intPoints;
        }
        else {
          this.d_current_item.puntos_cinefan = 0;
        }

        // Puntos YPF
        const puntosYPFBalance = option.lstBalances.find(balance => balance.enuPointsType === 2 && balance.intBalanceId === 0);
        if (puntosYPFBalance) {
          this.d_current_item.puntos_ypf = Item.intQty * puntosYPFBalance.intPoints;
        }
        else {
          this.d_current_item.puntos_ypf = 0;
        }

        // Entradas Cine Fan
        const entradasCineFanBalance = option.lstBalances.find(balance => balance.enuPointsType === 1 && (balance.intBalanceId === 4 || balance.intBalanceId === 9));
        if (entradasCineFanBalance) {
          this.d_current_item.entradas = Item.intQty * entradasCineFanBalance.intPoints;
        }
        else {
          this.d_current_item.entradas = 0;
        }

        this.d_current_item.item_category = "Merch";

        // Busco la categoria
        const category = this.findCategoryByCandyCode(Item.strMCode);

        this.d_current_item.item_category2 = category.strTitle;

        if (cine_selected) {
          this.d_current_item.city_id = cine_selected.strCity;
          this.d_current_item.theater_id = cine_selected.strName;
          this.d_current_item.location_id = cine_selected.strAddress;
        }

        this.d_current_item.item_list_name = category.strTitle;
        this.d_current_item.item_list_id = category.intCategoryId;

        this.d_current_item.index = Index;
        this.d_current_item.quantity = Item.intQty;

        // Agrego d_current_item
        this.d_datalayer.ecommerce.items.push(this.d_current_item);

        // Sumo 1 al Index
        Index = Index + 1;
      }, this); // Pasa el contexto actual al foreach
    },
    m_datalayer_set_payment: function () {
      // Actualizo el event
      this.d_datalayer.event = "add_payment_info";

      // Actualizo order_state
      this.d_datalayer.ecommerce.order_state = undefined;

      //Comprobamos si existe el elemento con id = ddlcardtype
      if ($("#ddlcardtype").length > 0) {
        //Si entra en el if significa que el elemento no está vacío
        //Entonces existe y podemos usarlo con seguridad
        // Actualizo payment_type con el valor del selector
        this.d_datalayer.ecommerce.payment_type = $("#ddlcardtype").val();
      }
      else {
        // Si el elemento no existe, actualizamos payment_type con tipo Canje
        this.d_datalayer.ecommerce.payment_type = "Canje";
      }

      //Comprobamos si existe el elemento con id = ddlccpayments
      if ($("#ddlccpayments").length > 0) {
        //Si entra en el if significa que el elemento no está vacío
        //Entonces existe y podemos usarlo con seguridad
        // Actualizo cuotas con el valor del selector
        this.d_datalayer.ecommerce.cuotas = parseInt($("#ddlccpayments").val());
      }
    }
  }
})

/*Section Ticket/Candy*/
window.$ = $;
window.jQuery = $;
//Defino la url del home
//window.SetWebUrl = function(strUrl){
//window.WEB_URL = strUrl;
//window.WEB_URL = 'http://cinemarkhoyts.nextdevelop.com.ar/';
//}

//test
//window.vm = vm;

window.ChangeCinemaHomeSelect = function (value) {
  vm.m_change_cinema_home(value);
}

window.ChangeCinemaSelect = function (value) {
  vm.m_change_cinema(value);
}

$('#btnNext, #btnVoucherValidate').click(function (e) {
  var datos = null;
  if (vm.d_json_candys) {
    datos = { candys: vm.d_cart_candys };
    //Agrego loading si es un voucher
    if (this.name == 'btnVoucherValidate') {
      if (functionsCandys.VoucherValidate()) {
        $('.voucher-loading').css('display', '');
      }
      else if ($('#txtVoucherCode').val().length == 0) {
        vm.m_show_popup({ idMsg: 1007 });
        e.preventDefault();
      }
    }
  }
  datos && $("#DataCurrentClient").val(JSON.stringify(datos));
});

/*Section Candy*/
window.SetDataCandy = function (data) {
  vm.d_json_candys = data;
}

window.SetCurrentDataCandy = function (data) {
  vm.d_subtotal_value = data.subtotal_value;
  vm.d_cart_candys = data.candys;
  vm.d_default_candys_service = data.default_candys_service;
  vm.d_total_candys_service = data.total_candys_service;
  vm.d_balance_types = data.balance_types;
  data.candys.forEach(element => {
    var candy = functionsCandys.GetCandy(vm.d_json_candys, element.strMCode, element.strBarcode);
    //Si tiene regla de grupo lo agrego a la lista de control.
    if (candy.strGroupRule) {
      vm.m_update_group_rule_candy(candy, true);
    }
  });
}

window.IsCartCandy = function () {
  return vm.d_cart_candys && vm.d_cart_candys.length > 0;
}

//Muestra el selector de cinemas
window.ShowSelectCinemas = function (d) {
  vm.m_show_popup_cinemas(d);
}

//Setea el usuario que se logeo
window.SetMember = function (d) {
  vm.d_member = d;
}

//Seteo los cinemas
window.SetCinemas = function (d) {
  vm.d_cinemas = d;
}

//Para Mostrar mensaje con kilometros disponibles.
window.ShowPopUpYpfKms = function (kms) {
  var args = { idMsg: 1, memberKms: kms, memberName: vm.d_member.strFirstName, Image: vm.d_get_url_ticketing + "images/serviclub-logo.png?v=" + vm.d_get_date_version_cache };
  vm.m_show_popup_image(args);
}

window.SetShowPromotionDesc = function (d) {
  vm.d_show_promotion_desc = d;
}

window.ShowCinemaHomePopup = function(d) {
  vm.m_show_popup_cinemas_home(null, 0, 0, 0, d);
}

///////////////////
// DATALAYER GA4 //
///////////////////

window.SetDataLayer = function (d) {
  vm.d_datalayer = d;
}

window.SetBaseItem = function (d) {
  vm.d_base_item = d;
}

window.SetCinemaDataLayer = function (d) {
  vm.d_cinema_selected = d;
}

window.PushDataLayer = function () {
  if (window.DataLayerGA4Enabled == "Y") {
    dataLayer.push({ ecommerce: null });
    dataLayer.push(vm.d_datalayer);
  }
}

window.DataLayerClick = function () {
  // Genero DataLayerGA4 Candys
  if (window.location.href.includes("nsMerchCandys")) {
    vm.m_datalayer_set_merchandisings(vm.d_cart_candys);
    window.PushDataLayer();
  }

  // Genero DataLayerGA4 Payment
  if (window.location.href.includes("nsPayment")) {
    vm.m_datalayer_set_payment();

    // Si el formulario esta completo
    if (Form1.checkValidity()) {
      window.PushDataLayer();
    }
  }

  // Guardo DataLayerGA4
  $("#HFDataLayerGA4").val(JSON.stringify(vm.d_datalayer));

}

//Inicia el push de Googletag services
//window.InitGoogletag();



// WEBPACK FOOTER //
// ./src/main.js